import { Component, OnInit, Injectable } from '@angular/core';
import * as d3 from "d3";
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { ValidationsService } from '../../services/validations.service';
import { CatalogosService } from '../../services/catalogos.service';
import { environment } from '../../../environments/environment';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { EmitterVisitorContext } from '@angular/compiler';

@Component({
  selector: 'app-transparencia-covid',
  templateUrl: './transparencia-covid.page.html',
  styleUrls: ['./transparencia-covid.page.scss']
})
@Injectable({
  providedIn: 'root'
})
export class TransparenciaCovidPage implements OnInit {
  faInfoCircle = faInfoCircle;
  faLink = faLink;

  loading: any = false;
  hasSession: any = false;
  llaveData: any = {};
  tramites: any = [];
  localRoute: any = {
    _value: null
  };
  confirmados: any = "";
  negativos: any = "";
  sospechosos: any = "";
  alcaldias: any = "";
  selectedViz: any = "";
  dataObject: any = "TEST";

  confirmadosTotal: any = 0;
  negativosTotal: any = 0;
  sospechososTotal: any = 0;

  confirmadosCDMX: any = 0;
  negativosCDMX: any = 0;
  sospechososCDMX: any = 0;

  intubadosId: any = "bar01";

  prueba = {
    x: "fecha",
    y: "serie1-1",
    style: {
      stroke: "#2977a2",
      fill: "#2ade60"
    },
    style_mouseover:{
      fill: "#98def5"
    },
    data: {}
  }

  hospitalizados_totales_styles: any = {
    style: { stroke: "#2977a2", fill: "#2ade60" },
    style_mouseover: { fill: "#98def5" }
  };

  filterIntubados: any = ["FECHA_INGRESO"];

  casosAsociados: any = [];
  casosColonia: any = [];
  casosAlcaldias: any = [];
  hospitalizados: any = [];

  hospitalizados_totales: string = "hospitalizados_totales";

  constructor(
    public route: Router,
    private router: ActivatedRoute,
    private sessionService: SessionService,
    private validateService: ValidationsService,
    private catalogosService: CatalogosService
  ) {
    this.localRoute = this.router.queryParams;
  }

  async ngOnInit() {
    this.loading = true;
    this.selectedViz = 'activos';

    await this.catalogosService.getHospitalizados()
      .then((results: any) => {
        this.hospitalizados = results.filters;
      });

    await this.catalogosService.getCasosColonia()
      .then((results: any) => {
        this.casosColonia = results;
      });

    await this.catalogosService.getCasosAlcaldias()
      .then((results: any) => {
        this.casosAlcaldias = results;
        this.confirmados = results.filters;

        results.filters.map((item) => {
          this.confirmadosTotal += item.count_confirmados;
          this.negativosTotal += item.count_negativos;
          this.sospechososTotal += item.count_sospechosos;
          // TODO refactor duplicate vars
          this.confirmadosCDMX += item.count_confirmados;
          this.negativosCDMX += item.count_negativos;
          this.sospechososCDMX += item.count_sospechosos;
        })
      });

    await this.catalogosService.getCasosAsociados()
      .then((results: any) => {
        this.casosAsociados = results.filters;
        console.log("this.casosAsociados => ", this.casosAsociados);
      });

    this.loading = false;
  }

  ngTotals (event) {
    let selected = this.confirmados.find(elem => elem._id === Number(event.target.value));

    this.confirmadosTotal = Number(event.target.value) == 0 ? this.confirmadosCDMX : selected.count_confirmados;
    this.negativosTotal = Number(event.target.value) == 0 ? this.negativosCDMX : selected.count_negativos;
    this.sospechososTotal = Number(event.target.value) == 0 ? this.sospechososCDMX : selected.count_sospechosos;
  }

  toggleViz(viz_name){
    this.selectedViz = viz_name;
  }
}
